import RouterUtil from '@/utils/RouterUtil';
import SessionUtil from '@/utils/SessionUtil';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
export default {
  name: 'GoTo',
  data() {
    return {
      showEmptyProgressOrder: false
    };
  },
  mounted() {
    this.goto();
  },
  activated() {
    this.goto();
  },
  methods: {
    goto() {
      if (RouterUtil.containsQuery(this.$route, 'reserve')) {
        StorageUtil.set('reserveMode', 'true');
        RouterUtil.go('/index', true);
        return;
      }
      if (RouterUtil.containsQuery(this.$route, 'proxy')) {
        StorageUtil.set('proxyMode', 'true');
        RouterUtil.go('/index', true);
        return;
      }
      if (RouterUtil.containsQuery(this.$route, 'voice')) {
        StorageUtil.set('voiceMode', 'true');
        RouterUtil.go('/index', true);
        return;
      }
      if (RouterUtil.containsQuery(this.$route, 'orders')) {
        RouterUtil.go('/order/list?ref=goto', true);
        return;
      }
      if (RouterUtil.containsQuery(this.$route, 'progress')) {
        if (!SessionUtil.isLogin()) {
          RouterUtil.go('/login', true);
          return;
        }
        this.getProgressOrder();
        return;
      }
      if (RouterUtil.containsQuery(this.$route, 'user')) {
        RouterUtil.go('/user?ref=goto', true);
        return;
      }
      RouterUtil.go('/index', true);
    },
    getProgressOrder() {
      if (!SessionUtil.isLogin()) {
        return;
      }
      const that = this;
      OrderApi.getProgressOrder().then(function (result) {
        if (result.orderData) {
          StorageUtil.setObject('orderData', result.orderData);
          RouterUtil.go('/order/progress', true);
        } else {
          OrderApi.getWaitDispatchOrder().then(function (result) {
            if (result.response.data.success) {
              RouterUtil.go('/order/calling', true);
            } else {
              that.showEmptyProgressOrder = true;
            }
          }).catch(function (error) {
            that.showEmptyProgressOrder = true;
          });
        }
      }).catch(function (error) {
        that.showEmptyProgressOrder = true;
      }).finally(function () {
        document.title = '行程状态';
      });
    }
  }
};